// frontend/src/components/Artists/ArtistCard.js
import React from "react";
import "./ArtistCard.css";

const ArtistCard = ({ artist, onClick }) => {
  // Use imageUrl if available, otherwise use a placeholder
  const artistImage = artist.imageUrl || "/images/default-artist.jpg";

  return (
    <div onClick={onClick} className="artist-card">
      <div className="artist-card-image-container">
        <img
          src={artistImage}
          alt={artist.fullName || `${artist.fname} ${artist.lname}`}
          className="artist-card-image"
        />
      </div>
      <div className="artist-card-overlay">
        <h2 className="artist-card-title">
          {artist.fullName || `${artist.fname} ${artist.lname}`}
        </h2>
      </div>
    </div>
  );
};

export default ArtistCard;
